import { getCurrentDate, isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

const UNIT_OPTIONS = [
  { label: "--Select--", value: "" },
  { label: "Tablet(s)", value: "Tablet(s)" },
  { label: "Capsule(s)", value: "Capsule(s)" },
  { label: "mL", value: "mL" },
  { label: "mg", value: "mg" },
  { label: "Unit(s)", value: "Unit(s)" },
  { label: "Packet(s)", value: "Packet(s)" },
  { label: "Bottle(s)", value: "Bottle(s)" },
  { label: "Other", value: "Other" },
];

const computationRules = (formData, key) => {
  let returnResult = {};
  // if(key==='status' && formData.status==='Not Started' ){
  //   return {
  //     status: 'Not Started',
  //     activity_status: 'Not Started'
  //   };
  // }
  // if(key==='status' && formData.status==='Dispensed' ){
  //   return {
  //     activity_status: 'Completed'
  //   };
  // }
  
  // Avoid feedback loops when status or activity_status themselves are being changed
  if (key === 'status' || key === 'activity_status') {
    return returnResult;
  }
  
  // Check if any Medication Dispensing Details fields have values
  const medicationDispensingFields = [
    'medication_name',
    'dispense_date',
    'quantity_dispensed',
    'unit',
    'strength',
    'sig_directions',
    'days_supply',
    'refills',
    'ndc'
  ];
  
  const hasAnyMedicationDispensingValue = medicationDispensingFields.some(field => {
    const value = formData[field];
    return value !== null && value !== undefined && value !== '';
  });
  
  // If any medication dispensing detail is entered, auto-update statuses
  if (hasAnyMedicationDispensingValue) {
    returnResult.status = 'Dispensed';
    returnResult.activity_status = 'Completed';
  }
  
  return returnResult;
}
const computationRulesForDispensedRx = (formData, key) => {
  let returnResult = {};
  const currentStatus = isSet(formData.status, "Not Started");
  const currentActivityStatus = isSet(formData.activity_status, "Not Started");
  if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
    returnResult.status = "Pending";  
    returnResult.activity_status = "Pending";
  }
  if(key === 'status' && formData.status) {
    const status = formData.status;
    // Check if provider has signed (medical_examiner_signature_two exists and is not empty)
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    switch(status) {
        case 'Not Started':
            returnResult.activity_status = 'Not Started';
            break;
        case 'Pending':
            returnResult.activity_status = 'Pending';
            break;
        case 'Normal':
            // If provider signed, set to Completed; otherwise Pending
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Abnormal':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Negative':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Positive':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Dispensed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Administered':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Failed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Passed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Non-Negative':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        case 'Cancelled':
            returnResult.activity_status = 'Cancelled';
            break;
        case 'Inconclusive':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        default:
            // No change if status doesn't match any case
            break;
    }
  }

  if(key === 'provider_signature' && formData.status) {
    const status = formData.status;
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    // Completion statuses that should become "Completed" when provider signs
    const completionStatuses = ['Normal', 'Abnormal', 'Negative', 'Positive', 'Dispensed', 'Administered', 'Failed', 'Passed'];
    
    if (completionStatuses.includes(status)) {
      returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    }
  }
  return returnResult;
}

export const DispensedRx = async (props) => {
  const stackedFieldStyle = {
    layout: "stacked",
    showContainerBorder: false,
    labelWrap: false,
    isLabel: false,
  };

  let charts = [
    {
      type: "Grid",
      col: "col-lg-3",
      data: [
        { type: "PatientDetails", employeeDetails: props.employeeDetails, visitDetails: props.visitDetails },
        { type: "CompanyDetails", companyDetails: props.companyDetails },
      ],
    },
    {
      type: "Tab",
      col: "col-lg-9",
      data: [
        {
          id: "dispensed_rx_details",
          label: "Medication Dispensing",
          data: [
            {
              label: "Medication Dispensing Details",
              labelStyle: "fw-semibold",
              fieldProps: stackedFieldStyle,
              fields: [
                {
                  type: "NewTextInput",
                  label: "Medication Name",
                  placeholder: "Enter medication name",
                  required: true,
                  className: "form-control form-control-solid",
                  name: "medication_name",
                  col: "col-lg-6 col-md-6 col-12 border-0",
                },
                {
                  type: "NewDate",
                  label: "Dispense Date",
                  required: true,
                  placeholder: "MM / DD / YYYY",
                  className: "form-control form-control-solid",
                  name: "dispense_date",
                  col: "col-lg-6 col-md-6 col-12 border-0",
                },
                {
                  type: "NewTextInput",
                  label: "Quantity Dispensed",
                  placeholder: "Enter quantity",
                  className: "form-control form-control-solid",
                  name: "quantity_dispensed",
                  col: "col-lg-6 col-md-6 col-12 border-0",
                },
                {
                  type: "NewSelectList",
                  label: "Unit",
                  placeholder: "Select...",
                  className: "form-control form-control-solid",
                  options: UNIT_OPTIONS,
                  name: "unit",
                  col: "col-lg-6 col-md-6 col-12 border-0",
                },
                {
                  type: "NewTextInput",
                  label: "Strength",
                  placeholder: "Enter strength",
                  className: "form-control form-control-solid",
                  name: "strength",
                  col: "col-lg-6 col-md-6 col-12 border-0",
                },
                {
                  type: "NewTextInput",
                  label: "Sig / Directions",
                  placeholder: "Enter sig or directions",
                  className: "form-control form-control-solid",
                  name: "sig_directions",
                  col: "col-lg-6 col-md-6 col-12 border-0",
                },
                {
                  type: "NewTextInput",
                  label: "Days Supply",
                  placeholder: "Enter days supply",
                  className: "form-control form-control-solid",
                  name: "days_supply",
                  col: "col-lg-6 col-md-6 col-12 border-0",
                },
                {
                  type: "NewTextInput",
                  label: "Refills",
                  placeholder: "Enter refills",
                  className: "form-control form-control-solid",
                  name: "refills",
                  col: "col-lg-6 col-md-6 col-12 border-0",
                },
                {
                  type: "NewTextInput",
                  label: "NDC",
                  placeholder: "Enter National Drug Code",
                  className: "form-control form-control-solid",
                  name: "ndc",
                  col: "col-lg-6 col-md-6 col-12 border-0",
                },
                // {
                //   type: "Checkbox",
                //   label: "Label Printed",
                //   name: "label_printed",
                //   col: "col-lg-6 col-md-6 col-12 border-0",
                // },
              ],
            },
            {
      label: "Review / Completion",
      labelStyle: "fw-semibold",
      fields: [
        {
          type: "ProviderSignOff",
          col: "col-12",
          fields: [
            { label: "Signature PIN", name: "provider_pin", col: "col-12" },
            { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
            { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
            {
              label: "Final Results",
              type: "SelectList",
              name: "status",
              col: "col-12",
              // Previous options:
              // options: optionsToKeyValuePairs(["Not Started", "Dispensed", "Not Dispensed"]),
              // New standard options:
              options: optionsToKeyValuePairs(
                [
                  "Not Started",
                  "Pending",
                  "Normal",
                  "Abnormal",
                  "Negative",
                  "Positive",
                  "Dispensed",
                  "Administered",
                  "Failed",
                  "Passed",
                  "Non-Negative",
                  "Cancelled",
                  "Inconclusive",
                ],
                false
              ),
              statusBasedColor: true,
            },
            {
              label: "Activity Status",
              type: "SelectList",
              name: "activity_status",
              col: "col-12",
              // Previous options:
              // options: optionsToKeyValuePairs(["Not Started", "Ordered", "Ready for Review", "Completed", "Cancelled"]),
              // New standard options:
              options: optionsToKeyValuePairs(
                [
                  "Not Started",
                  "Pending",
                  "Pending Lab Confirmation",
                  "Pending MRO Confirmation",
                  "Ready for Review",
                  "Completed",
                  "Cancelled",
                ],
                false
              ),
              statusBasedColor: true,
            },
          ],
        },
      ],
    },
          ],
        },
        { id: "Images", label: "Images", data: [] },
      ],
    },
  ];

  // Auto-populate medication_name from EMR field label (selected option when provider clicked Accept/Replace)
  const emrFieldLabel = props.emrFieldLabel || "";
  const defaultValue = {
    dispense_date: getCurrentDate(),
    status: "Not Started",
    suggested_status: "Not Started",
    activity_status: "Not Started",
    medication_name: emrFieldLabel,
  };

  const buttons = {};
  const headers = [{ type: "Tab", data: [] }];

  return { 
    buttons, 
    charts, 
    defaultValue, 
    headers, 
    computationFunction: (formData, key) => ({
      ...computationRulesForDispensedRx(formData, key),
      // ...computationRules1(formData, key),
    }) 
  };

  
};
